bovoApp.controller('WeightHistoryController', ['$scope', 'Billing', '$location', '$interval',
  function ($scope, Billing, $location, $interval) {
    var ACTIVE_STATUSES = ['pending', 'processing', 'prices_pending'];
    var LIST_REFRESH_MS = 6000;
    var DETAIL_REFRESH_MS = 5000;
    var listTimer = null;
    var detailTimer = null;
    var requestSeq = 0; // Eski (geç dönen) yanıtların yenisini ezmesini önler.

    $scope.loading = false;
    $scope.loaded = false;
    $scope.loadError = null;
    $scope.data = null;

    function emptyFilter() {
      return {
        page: 1,
        status: '',
        date_from: null, // <input type="date"> Date nesnesi tutar
        date_to: null
      };
    }

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function formatDate(d) {
      if (!d) {
        return '';
      }
      if (!(d instanceof Date)) {
        return d;
      }
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }

    function buildParams() {
      var f = $scope.filterData;
      var params = { page: f.page };
      if (f.status) {
        params.status = f.status;
      }
      if (f.date_from) {
        params.date_from = formatDate(f.date_from);
      }
      if (f.date_to) {
        params.date_to = formatDate(f.date_to);
      }
      return params;
    }

    function isActive(status) {
      return ACTIVE_STATUSES.indexOf(status) !== -1;
    }

    $scope.filterData = emptyFilter();

    $scope.hasFilter = function () {
      var f = $scope.filterData;
      return !!(f.status || f.date_from || f.date_to);
    };

    $scope.hasRows = function () {
      return !!($scope.data && $scope.data.history && $scope.data.history.data && $scope.data.history.data.length > 0);
    };

    /**
     * @param {boolean} silent true ise yükleniyor göstergesi/hata kutusu değişmez (otomatik yenileme).
     */
    $scope.loadHistory = function (silent) {
      var seq = ++requestSeq;
      if (!silent) {
        $scope.loading = true;
        $scope.loadError = null;
      }

      Billing.getWeightUpdateHistory(buildParams()).success(function (data) {
        if (seq !== requestSeq) {
          return;
        }
        $scope.data = data;
        $scope.loaded = true;
        $scope.loading = false;
        $scope.loadError = null;
      }).error(function (data, status) {
        if (seq !== requestSeq) {
          return;
        }
        $scope.loading = false;
        if (silent) {
          return; // Arka plandaki yenileme hatası ekranı bozmasın.
        }
        $scope.loadError = status === 403
          ? 'Bu sayfayı görüntülemek için yetkiniz yok.'
          : ((data && data.message) || 'Geçmiş yüklenirken hata oluştu!');
      });
    };

    $scope.getPage = function (page) {
      $scope.filterData.page = page;
      $scope.loadHistory();
    };

    // Filtre değişince 1. sayfadan başla; aksi halde sayfa 3'teyken boş sonuç gelir.
    $scope.onFilterChange = function () {
      $scope.filterData.page = 1;
      $scope.loadHistory();
    };

    $scope.clearFilter = function () {
      $scope.filterData = emptyFilter();
      $scope.loadHistory();
    };

    $scope.getStatusLabel = function (status) {
      switch (status) {
        case 'completed': return 'Tamamlandı';
        case 'prices_pending': return 'Fiyat Güncelleniyor';
        case 'processing': return 'İşleniyor';
        case 'pending': return 'Bekliyor';
        case 'failed': return 'Başarısız';
        default: return status;
      }
    };

    $scope.getStatusClass = function (status) {
      switch (status) {
        case 'completed': return 'label-success';
        case 'prices_pending': return 'label-primary';
        case 'processing': return 'label-info';
        case 'pending': return 'label-warning';
        case 'failed': return 'label-danger';
        default: return 'label-default';
      }
    };

    $scope.isActive = isActive;

    $scope.sourceLabel = function (source) {
      if (!source || source === 'excel') {
        return 'Excel';
      }
      if (source.indexOf('api:') === 0) {
        return 'API · ' + source.substring(4).toUpperCase();
      }
      return source;
    };

    // Detay dizileri sunucuda sınırlanır; gerçek toplam "<anahtar>_total" alanındadır.
    $scope.total = function (response, key) {
      if (!response) {
        return 0;
      }
      if (response[key + '_total'] !== undefined && response[key + '_total'] !== null) {
        return response[key + '_total'];
      }
      return response[key] ? response[key].length : 0;
    };

    $scope.shown = function (response, key) {
      return response && response[key] ? response[key].length : 0;
    };

    $scope.progressPercent = function (progress) {
      if (!progress || !progress.total_jobs) {
        return 0;
      }
      return Math.min(100, Math.round(progress.completed_jobs / progress.total_jobs * 100));
    };

    // ---- Detay modalı ----

    $scope.openDetail = function (item) {
      $scope.selectedItem = angular.copy(item);
      $scope.detailError = null;
      $('#weightHistoryDetail').modal('show');
      $scope.fetchDetail(item.id, true);
    };

    $scope.fetchDetail = function (importId, startPolling) {
      Billing.checkWeightUpdateStatus(importId).success(function (response) {
        if (!$scope.selectedItem || $scope.selectedItem.id !== importId) {
          return;
        }

        $scope.selectedItem.status = response.status;
        $scope.selectedItem.response = response.response;
        $scope.selectedItem.exception = response.exception;
        $scope.selectedItem.updated_at = response.updated_at;
        $scope.detailError = null;

        if (isActive(response.status)) {
          if (startPolling) {
            $scope.startDetailRefresh(importId);
          }
        } else {
          $scope.stopDetailRefresh();
          // Bittiyse listedeki satırı da güncelle.
          $scope.loadHistory(true);
        }
      }).error(function (data, status) {
        $scope.stopDetailRefresh();
        $scope.detailError = status === 403
          ? 'Bu kaydı görüntülemek için yetkiniz yok.'
          : ((data && data.message) || 'Detay yüklenemedi.');
      });
    };

    $scope.startDetailRefresh = function (importId) {
      $scope.stopDetailRefresh();
      detailTimer = $interval(function () {
        $scope.fetchDetail(importId, false);
      }, DETAIL_REFRESH_MS);
    };

    $scope.stopDetailRefresh = function () {
      if (detailTimer) {
        $interval.cancel(detailTimer);
        detailTimer = null;
      }
    };

    $('#weightHistoryDetail').on('hidden.bs.modal.weightHistory', function () {
      $scope.stopDetailRefresh();
    });

    // ---- Liste otomatik yenileme: yalnızca bekleyen/işlenen kayıt varken ----

    function hasActiveRows() {
      if (!$scope.hasRows()) {
        return false;
      }
      return $scope.data.history.data.some(function (row) {
        return isActive(row.status);
      });
    }

    listTimer = $interval(function () {
      if (document.hidden || $scope.loading || !hasActiveRows()) {
        return;
      }
      $scope.loadHistory(true);
    }, LIST_REFRESH_MS);

    $scope.$on('$destroy', function () {
      $scope.stopDetailRefresh();
      if (listTimer) {
        $interval.cancel(listTimer);
        listTimer = null;
      }
      $('#weightHistoryDetail').off('hidden.bs.modal.weightHistory');
    });

    // /orders?order_id= OrderListController tarafından işlenir (kargo detayını açar).
    $scope.openOrder = function (orderId) {
      window.open('/orders?order_id=' + encodeURIComponent(orderId), '_blank');
    };

    $scope.goToInvoice = function () {
      $location.path('/invoice');
    };

    // Init
    $scope.loadHistory();
  }
]);
